import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

// Reference: https://github.com/scttcper/ngx-toastr/blob/master/src/app/pink.toast.ts
@Component({
  selector: 'app-warning-toastr',
  templateUrl: './warning-toastr.component.html',
  styleUrl: './warning-toastr.component.scss'
})

export class WarningToastrComponent extends Toast {
  closeToast(): void {
    this.remove();
  }
}
